if (document.getElementById("slideBtn")) {
  document.getElementById("slideBtn").addEventListener("click", () => {
    document.getElementById("slideBtn").classList.toggle("active");
    document.getElementById("slideMenu").classList.toggle("active");
  });

  document
    .getElementById("slideNavCollection")
    .addEventListener("click", () => {
      document.getElementById("slideMenu").classList.add("second");
    });

  document
    .getElementById("slideNavSecondBack")
    .addEventListener("click", () => {
      document.getElementById("slideMenu").classList.remove("second");
    });

  document.getElementById("headerSearchBtn").addEventListener("click", () => {
    document.getElementById("headerSearch").classList.add("active");
  });

  document.getElementById("headerSearchClose").addEventListener("click", () => {
    document.getElementById("headerSearch").classList.remove("active");
  });
}
